import { render, staticRenderFns } from "./AnswersOfQuestionN.vue?vue&type=template&id=0ff80c42&scoped=true&"
import script from "./AnswersOfQuestionN.vue?vue&type=script&lang=js&"
export * from "./AnswersOfQuestionN.vue?vue&type=script&lang=js&"
import style0 from "./AnswersOfQuestionN.vue?vue&type=style&index=0&id=0ff80c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff80c42",
  null
  
)

export default component.exports